/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./getBranding.defs.js";
export { main as default } from "./getBranding.defs.js";
